<ce-container>
    @if(hasError()){
    <ce-empty-state type="not-found" actionLabel="Log in" actionHref="auth/login">
        <h1 ce-empty-state-title>Error authenticating</h1>
        <p ce-empty-state-description>{{ auth0Service.errorMessage() || 'This may be due to an expired link, incorrect credentials, or a misconfigured redirect. Retry logging in.' }}</p>
    </ce-empty-state>
    } @else {
    <ce-empty-state type="unauthorized">
        <h2 ce-empty-state-title>{{ callBackMessage() }}</h2>
        <p ce-empty-state-description>Please wait while we are logging you in...</p>
    </ce-empty-state>
    }
</ce-container>
